import { defineFeatureFlags } from '@packages/feature-flags';

/**
 * Names are camelCase. `enabled` sets the value on each stand, the stand is `APP_STAND` of the
 * container (@packages/runtime-config). On dev and test a value can be overridden in the devtools panel.
 *
 * Example:
 *   newProfile: {
 *     description: 'New profile page, [FRT-123](https://tracker.yandex.ru/FRT-123)',
 *     enabled: { dev: true, test: false, prod: false },
 *   },
 */
export const featureFlagDefinitions = defineFeatureFlags({
  ratingsAndReviews: {
    description: '[FRT-8349](https://tracker.yandex.ru/FRT-8349)',
    enabled: { dev: false, test: false, prod: false },
  },
  candidatePicking: {
    description: '[FRT-8329](https://tracker.yandex.ru/FRT-8329)',
    enabled: { dev: true, test: true, prod: true },
  },
  manualNccConfirmation: {
    description: '[FRT-8462](https://tracker.yandex.ru/FRT-8462)',
    enabled: { dev: true, test: true, prod: true },
  },
});
